export default __webpack_public_path__ + "188be7d.png";